document.addEventListener('DOMContentLoaded', function () {
  initUrgencyWidgets();
});

function initUrgencyWidgets() {
  var widgets = document.querySelectorAll('[data-urgency-widget]');

  widgets.forEach(function (widget) {
    var blockId = widget.getAttribute('data-block-id');
    var durationHours = parseFloat(widget.getAttribute('data-duration-hours')) || 6;
    var startPercent = parseFloat(widget.getAttribute('data-start-percent')) || 68;
    var maxPercent = parseFloat(widget.getAttribute('data-max-percent')) || 94;
    var durationMs = durationHours * 60 * 60 * 1000;
    var storageKey = 'urgency_timer_end_' + blockId;

    var percentFill = widget.querySelector('[data-percent-fill]');
    var percentDisplay = widget.querySelector('[data-percent-display]');
    var countdownDisplay = widget.querySelector('[data-countdown-display]');

    var endTime = getOrCreateEndTime(storageKey, durationMs);

    function tick() {
      var now = Date.now();
      var remaining = endTime - now;

      if (remaining <= 0) {
        endTime = now + durationMs;
        localStorage.setItem(storageKey, endTime.toString());
        remaining = durationMs;
      }

      var fraction = 1 - (remaining / durationMs);
      fraction = Math.max(0, Math.min(1, fraction));

      var currentPercent = Math.round(startPercent + fraction * (maxPercent - startPercent));

      percentFill.style.width = currentPercent + '%';
      percentDisplay.textContent = currentPercent;
      countdownDisplay.textContent = formatTime(remaining);
    }

    tick();
    setInterval(tick, 1000);
  });
}

function getOrCreateEndTime(storageKey, durationMs) {
  var stored = localStorage.getItem(storageKey);
  var now = Date.now();

  if (stored) {
    var storedEnd = parseInt(stored, 10);
    if (!isNaN(storedEnd) && storedEnd > now) {
      return storedEnd;
    }
  }

  var newEnd = now + durationMs;
  localStorage.setItem(storageKey, newEnd.toString());
  return newEnd;
}

function formatTime(ms) {
  var totalSeconds = Math.floor(ms / 1000);
  var hours = Math.floor(totalSeconds / 3600);
  var minutes = Math.floor((totalSeconds % 3600) / 60);
  var seconds = totalSeconds % 60;

  return [hours, minutes, seconds]
    .map(function (n) { return n.toString().padStart(2, '0'); })
    .join(':');
}